module.exports = __webpack_public_path__ + "img/icon_service_two.028033bb.svg";